import {
  FileItem,
  FolderItem,
  Item,
  ItemType,
  ShortcutItem
} from '@inno-sdks/files'
import { i18nextContainer } from 'shared/configs/i18n/config'

import { readableFileTypes } from '../constants/readableFileTypes'
import { formatFileSize } from './formatFileSize'

export function getFileItemPrimaryInfo(file: FileItem) {
  return i18nextContainer.t(
    readableFileTypes[file.metaData.mimeType] ?? 'unknown',
    {
      ns: 'readableFileTypes'
    }
  )
}

export function getFolderItemPrimaryInfo(_folder: FolderItem) {
  // item count is not available from the backend currently
  return i18nextContainer.t('desktop.folder', {
    ns: 'translation'
  })
}

export function getShortcutItemPrimaryInfo(_shortcut: ShortcutItem) {
  return i18nextContainer.t('desktop.shortcut')
}

export function getItemPrimaryInfo(item: Item) {
  if (item.type === ItemType.Folder) {
    return getFolderItemPrimaryInfo(item)
  }
  if (item.type === ItemType.Shortcut) {
    return getShortcutItemPrimaryInfo(item)
  }
  return getFileItemPrimaryInfo(item)
}

export function getPublicItemPrimaryInfo(item: Item) {
  if (item.type === ItemType.File) {
    return getFileItemPrimaryInfo(item)
  }
  if (item.type === ItemType.Shortcut) {
    return getShortcutItemPrimaryInfo(item)
  }
  return undefined
}

export function getItemSizeInfo(item: Item) {
  if (item.type === ItemType.Folder || item.type === ItemType.Shortcut) {
    return ''
  }
  return formatFileSize(item.metaData.size)
}
